import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate, externalService } from '../../services';
import { IconButton } from '..';
import { identityState, messageDispatcher, cartState, productState, combineStates } from '../../store';
import { transformToWholeSalerObject } from '../../util'
import { js2xml } from 'xml-js';

export class ExportToWholeSalerCartComponent extends Component{
  hidePopup = () => this.props.hidePopup();
  exportToExternalCart = () => {
    const { cartItems, user, products } = this.props;
    let data = new URLSearchParams();
    const xmlContent = {'xmlContent' : 'true'};
    this.props.getExportStatus( true );
    const transformedData = js2xml( transformToWholeSalerObject( cartItems, user, products ), {compact: true, ignoreComment: true, spaces: 4} );
    data.append('ConfigResponse', transformedData );
    externalService.exportConfiguration( user.properties.HookUrl, data, xmlContent )
    .then( async () => {
      await this.props.addMessage( { timeout: 5000, messageText: translate( 'Successfully added to WholeSaler cart' ), messageType: 'confirmation' } );
      window.parent.postMessage(true, '*');
      this.props.getExportStatus( false );
    } )
    .catch( () => {
      this.props.addMessage( { timeout: 10000, messageText: translate( 'An error occured during export' ), messageType: 'error' } );
      this.props.getExportStatus( false );
    } );
    this.mounted && this.setState( { isAdding: false } );
    this.props.hidePopup();
  }
  
  render(){
    return <div className="export-cart-panel" >
        <div className="actions" >
          <IconButton text={ translate( 'Cancel' ) } onClick={ this.hidePopup } />
          <IconButton className="blue-button" text={ translate( 'OK' ) } onClick={ this.exportToExternalCart }/>
        </div>
      </div>;
  }
}

export const ExportToWholeSalerCart = connect( combineStates( cartState, identityState, productState ), messageDispatcher )( ExportToWholeSalerCartComponent );
